<template>
  <v-container :class="['pa-0', 'mt-2']">
    <h3 v-html="title" v-if="title" :class="['title', 'font-weight-light']" />
    <v-list three-line dense :class="['mt-2']">
      <template v-for="(member, index) in members">
        <v-list-tile :key="index">
          <v-list-tile-action>
            <v-icon>{{ icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-html="member.name" :title="lang.viewMoreInfo(member.name)" @click="goToResource('/artists', member.id)" :class="['item-clickable', $root.colors.primaryText]" />
            <v-list-tile-sub-title v-html="member.instrument" />
            <v-list-tile-sub-title v-if="member.otherBands.length">{{ lang.otherBands }}:
              <template v-for="(band, i) in member.otherBands">
                <router-link :class="[$root.colors.primaryText]" :title="lang.viewMoreInfo(band.name)" :key="i" :to="`/bands/${band.id}`" v-html="band.name" /><span :key="i + '-comma'" v-if="i < member.otherBands.length - 1">, </span>
              </template>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset :key="index + '-divider'" :class="['mt-1']" v-if="index < members.length - 1" />
      </template>
    </v-list>
    <warning :message="lang.recordsNotFound(title)" v-if="!members.length" />
  </v-container>
</template>
<script>
import methods from '../helpers/methods'
import lang from '../helpers/lang'

export default {
  name: 'BandMembers',
  mixins: [
    methods
  ],
  data () {
    return {
      lang
    }
  },
  props: {
    /**
     * Band members array
     * @array
     */
    members: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    /**
     * List title
     * @string
     */
    title: {
      type: String,
      required: false
    },
    /**
     * List item icon
     * @string
     */
    icon: {
      type: String,
      required: false,
      default: 'mdi-account'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/band-members.vue